import * as borogove from "borogove";
import { createContext, useContext } from "react";
import { useOutletContext } from "react-router";
import { Switch, FormControlLabel } from "@mui/material";

export type SettingsData = {
	enterIsSend: boolean;
	richTextToolbar: boolean;
	audibleNotifications: boolean;
};
export const SettingsContext = createContext<SettingsData>({
	enterIsSend: true,
	richTextToolbar: false,
	audibleNotifications: false,
});

export const Settings = () => {
	const { persistence, setSettings } = useOutletContext<{
		persistence: borogove.persistence.KeyValueStore;
		setSettings: (x: SettingsData) => void;
	}>();
	const settings = useContext(SettingsContext);
	const { audibleNotifications, enterIsSend, richTextToolbar } = settings;

	return (
		<section>
			<h1>Settings</h1>
			<FormControlLabel
				control={
					<Switch
						checked={enterIsSend}
						onChange={(e) => {
							persistence.set(
								"config#enterIsSend",
								e.target.checked ? "true" : "false",
							);
							setSettings({ ...settings, enterIsSend: e.target.checked });
						}}
					/>
				}
				label="Enter is Send"
			/>

			<FormControlLabel
				control={
					<Switch
						checked={richTextToolbar}
						onChange={(e) => {
							persistence.set(
								"config#richTextToolbar",
								e.target.checked ? "true" : "false",
							);
							setSettings({ ...settings, richTextToolbar: e.target.checked });
						}}
					/>
				}
				label="Formatting toolbar"
			/>

			<FormControlLabel
				control={
					<Switch
						checked={audibleNotifications}
						onChange={(e) => {
							persistence.set(
								"config#audibleNotifications",
								e.target.checked ? "true" : "false",
							);
							setSettings({
								...settings,
								audibleNotifications: e.target.checked,
							});
						}}
					/>
				}
				label="Audible notifications"
			/>
		</section>
	);
};
